import { useAuth } from '../../contexts/AuthContext';
import { Route, Routes, useNavigate } from 'react-router-dom';
import OnboardingTracker from '../Onboarding';
import SharedHeader from '../layout/SharedHeader';
import CertificatesSection from '../profile/certificates/CertificatesSection';
import MedicalSection from '../profile/medical/MedicalSection';
import AircraftSection from '../profile/aircraft/AircraftSection';
import ExperienceSection from '../profile/experience/ExperienceSection';
  

const ProfileFlow = () => {
  const { db, user } = useAuth();
  const navigate = useNavigate();

  const handleOnboardingComplete = () => {
    navigate('/chat');
  };

  if (!user) {
    console.log('User not found, redirecting to login');
    return <navigate to="/login" replace />;
  }

  return (
    <div className="min-h-screen bg-neutral-white">
      <SharedHeader />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="bg-white rounded-lg shadow">
          <Routes>
            <Route 
              path="/" 
              element={
                <OnboardingTracker 
                  db={db} 
                  onComplete={handleOnboardingComplete} 
                />
              } 
            />
            <Route path="/certificates" element={<CertificatesSection db={db} />} />
            <Route path="/medical" element={<MedicalSection db={db} />} />
            <Route path="/aircraft" element={<AircraftSection db={db} />} />
            <Route path="/experience" element={<ExperienceSection db={db} />} />
          </Routes>
        </div>
      </div>
    </div>
  );
};

export default ProfileFlow;